import * as R from 'ramda'

export function getGameCatalog(state) {
  return R.path(['gameCatalog', 'categories'], state)
}
